

















import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import 'share-api-polyfill';

const SHARE_PROVIDERS = Object.freeze({
  copy: true,
  email: true,
  print: false,
  sms: true,
  messenger: true,
  facebook: true,
  whatsapp: true,
  twitter: true,
  linkedin: true,
  telegram: true,
  skype: false,
  lang: 'en'
});

@Component({})
export default class ShareButton extends Vue {
  @Prop({required: true})
  title!: string;

  @Prop({required: true})
  text!: string;

  @Prop({required: false, default: null})
  url!: string | null;

  @Prop({required: false, default: true})
  small!: boolean;

  @Prop({required: false})
  color?: string;

  async share() {
    const {title, text, url} = this;
    // @ts-ignore
    return navigator.share(
            {
              title,
              text,
              url: url || window.location.href
            },
            SHARE_PROVIDERS
    );
  }
}
